<section>
  <mat-card
    class="card"
    *ngFor="let content of list"
    [style]="{
      'background-color': landing2 ? '#efecea' : '#373534',
      color: landing2 ? '#000' : '#fff'
    }"
  >
    <mat-card-header class="card--header">
      <mat-card-title class="card--header__title">
        <p class="text-truncate modelTitle">
          {{
            content.vehicle?.model ||
              content.model ||
              content.redPlateId ||
              content.id ||
              pendingModel
          }}
        </p>
        <p
          *ngIf="
            type === 'vehicles' &&
            content.requestStatus != 'PENDING_APPROVAL' &&
            !landing2 &&
            requestType !== requestTypeEnum.ES &&
            requestType !== 'transfer'
          "
          class="card--header__status"
          [style]="
            content.requestStatus === 'APPROVED' ||
            content.requestStatus === 'FINISHED'
              ? 'background-color: #2DBF56; min-width: 145px;'
              : content.requestStatus === 'REJECTED'
                ? 'background-color: #ce0f0c; min-width: 145px;'
                : 'background-color: #F0B212; min-width: 145px;'
          "
        >
          {{
            content.requestStatus
              ? this.translate.translateRequestStatus(content.requestStatus)
              : noData
          }}
        </p>
        <p
          *ngIf="
            type === 'vehicles' &&
            content.requestStatus === 'PENDING_APPROVAL' &&
            requestType !== requestTypeEnum.ES
          "
          class="card--header__status"
          style="background-color: #f0b212; min-width: 145px"
        >
          {{
            content.currentApprover
              ? ('approver'
                | i18next
                  : {
                      name:
                        content.currentApprover.fullName ||
                        content.currentApprover.collective
                    })
              : ('pendingApproval' | i18next)
          }}
        </p>
        <p
          class="card--header__appraisalTag"
          *ngIf="content.appraisalRequested"
        >
          {{ 'tagAppraisal' | i18next }}
        </p>
        <p class="card--header__booked" *ngIf="content.booking">
          {{ 'tagBooked' | i18next }}
        </p>
        <p
          class="card--header__status"
          *ngIf="type === 'authorizations'"
          [style]="
            content.requestStatus === 'PENDING_APPROVAL'
              ? 'background-color: #F0B212;'
              : content.requestStatus === 'REJECTED'
                ? 'background-color: #CE0F0C;'
                : 'background-color: #2DBF56;'
          "
        >
          {{
            content.requestStatus !== 'REJECTED' &&
            content.requestStatus !== 'PENDING_APPROVAL'
              ? this.translate.translateRequestStatus('APPROVED')
              : this.translate.translateRequestStatus(content.requestStatus)
          }}
        </p>
      </mat-card-title>
      <button
        *ngIf="
          (requestType === requestTypeEnum.REQUESTS &&
            this.state === 'active') ||
          authorizationType === authorizationEnum.REQUESTS ||
          authorizationType === 'requestsPEC'
        "
        mat-button
        [matMenuTriggerFor]="menu"
      >
        <div
          style="
            color: #c8f546;
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            flex-wrap: nowrap;
          "
          [style]="{ color: landing2 ? 'black' : '#c8f546' }"
        >
          <span class="mobile-hide">{{
            'requestListActions' | i18next | uppercase
          }}</span>
          <img
            *ngIf="!landing2"
            src="../../../../assets/icons/more.svg"
            alt="Más acciones"
          />
          <img
            *ngIf="landing2"
            src="../../../../assets/icons/more_black.svg"
            alt="Más acciones"
          />
        </div>
      </button>
      <mat-menu #menu="matMenu" class="card--header__actionsList">
        <button
          class="card--header__btn"
          (click)="seeDetail(content.requestNumber, content.requestType)"
        >
          {{ 'btnSeeDetail' | i18next | uppercase }}
        </button>
        <button
          class="card--header__btn"
          (click)="openCancelModal(content.requestNumber)"
          *ngIf="
            content.requestType !== requestTypeMayus.proyect &&
            content.cancellable &&
            this.state === 'active'
          "
        >
          {{ 'btnCancel' | i18next | uppercase }}
        </button>
        <button
          class="card--header__btn"
          (click)="openCancelModalProjectRegu(content.requestNumber)"
          *ngIf="
            authorizationType !== authorizationEnum.REQUESTS &&
            authorizationType !== 'requestsPEC' &&
            content.requestType === requestTypeMayus.proyect &&
            content.projectSubType === projectTypeEnum.REGU
          "
        >
          {{ 'btnCancel' | i18next | uppercase }}
        </button>
        <button
          class="card--header__btn"
          *ngIf="
            ((authorizationType === authorizationEnum.REQUESTS ||
              authorizationType === 'requestsPEC') &&
              content.requestType === requestTypeMayus.proyect) ||
            requestType === requestTypeEnum.REQUESTS
          "
          (click)="modifyDetail(content.requestNumber, content.requestType)"
        >
          {{ 'modify' | i18next | uppercase }}
        </button>
        <button
          *ngIf="content.fromTransferId"
          class="card--header__btn"
          (click)="
            extendTransfer(
              content.vehicle.vin,
              content.deliveryDate,
              content.returnDate
            )
          "
        >
          {{ 'extendTransfer' | i18next | uppercase }}
        </button>
        <div
          class="buttons-if"
          *ngIf="
            (content.requestType === requestTypeMayus.dotArr ||
              content.requestType === requestTypeMayus.campaigns ||
              content.requestType === requestTypeMayus.function) &&
            type !== 'authorizations'
          "
        >
          <button
            class="card--header__btn"
            (click)="requestAppraisal(content.requestNumber)"
            *ngIf="!content.appraisalRequested"
          >
            {{ 'appraisal' | i18next | uppercase }}
          </button>
          <button
            *ngIf="!content.booking"
            class="card--header__btn"
            (click)="redirectToBookVehicle(content.requestNumber)"
          >
            {{ 'bookTitle' | i18next | uppercase }}
          </button>
          <button
            *ngIf="content.booking"
            class="card--header__btn"
            (click)="modifyBookVehicle(content)"
          >
            {{ 'modifyBookVehicle' | i18next | uppercase }}
          </button>
          <button
            *ngIf="
              content.booking &&
              content.requestStatus !== 'SENT_TO_FACTORY' &&
              content.requestStatus !== 'IN_PRODUCTION'
            "
            class="card--header__btn"
            (click)="openCancelModalBook(content.requestNumber)"
          >
            {{ 'bookCancelTitle' | i18next | uppercase }}
          </button>
        </div>
      </mat-menu>

      <button
        *ngIf="
          requestType === requestTypeEnum.REQUESTS &&
          this.state === 'inactive' &&
          landing2
        "
        mat-button
        [matMenuTriggerFor]="menu2"
      >
        <div
          style="
            color: #c8f546;
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            flex-wrap: nowrap;
          "
          [style]="{ color: landing2 ? 'black' : '#c8f546' }"
        >
          <span class="mobile-hide">{{
            'requestListActions' | i18next | uppercase
          }}</span>
          <img
            *ngIf="!landing2"
            src="../../../../assets/icons/more.svg"
            alt="Más acciones"
          />
          <img
            *ngIf="landing2"
            src="../../../../assets/icons/more_black.svg"
            alt="Más acciones"
          />
        </div>
      </button>
      <mat-menu #menu2="matMenu" class="card--header__actionsList">
        <button
          class="card--header__btn"
          (click)="seeDetail(content.requestNumber, content.requestType)"
        >
          {{ 'btnSeeDetail' | i18next | uppercase }}
        </button>
      </mat-menu>

      <button
        *ngIf="
          requestType === requestTypeEnum.JUDGEMENTS &&
          content.requestStatus === 'PENDING_QUALITY'
        "
        mat-button
        [matMenuTriggerFor]="menuJud"
      >
        <div
          style="
            color: #c8f546;
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            flex-wrap: nowrap;
          "
          [style]="{ color: landing2 ? 'black' : '#c8f546' }"
        >
          <span class="mobile-hide">{{
            'requestListActions' | i18next | uppercase
          }}</span>
          <img
            *ngIf="!landing2"
            src="../../../../assets/icons/more.svg"
            alt="Más acciones"
          />
          <img
            *ngIf="landing2"
            src="../../../../assets/icons/more_black.svg"
            alt="Más acciones"
          />
        </div>
      </button>
      <mat-menu #menuJud="matMenu" class="card--header__actionsList">
        <button
          class="card--header__btn"
          (click)="openCancelJudgementModal(content.id)"
        >
          {{ 'btnCancel' | i18next | uppercase }}
        </button>
      </mat-menu>
    </mat-card-header>
    <!-- Resquest list (vehicles) -->
    <mat-card-content
      class="vehicles"
      *ngIf="type === 'vehicles' && requestType === requestTypeEnum.REQUESTS"
    >
      <div class="content--item">
        <p class="content--info">
          {{ content.requestNumber ? content.requestNumber : pendingData }}
        </p>
        <p class="content--text">{{ 'requestNumber' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.vehicle?.plateNumber
              ? content.vehicle?.plateNumber
              : pendingPlate
          }}
        </p>
        <p class="content--text">{{ 'plateNumber' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.requestType === 'LEASING'
              ? translate.translateRequestTypes('EMPLOYEE_LEASING')
              : translate.translateRequestTypes(
                  content.orderType ? content.orderType : content.requestType
                )
          }}
          <span
            class="content--info__loanSubtype"
            requestTypeEnum
            *ngIf="content.requestType === 'LOAN'"
            >{{ translate.translateRequestSubtypes(content.loanType) }}</span
          >
        </p>
        <p class="content--text">{{ 'requestType' | i18next }}</p>
      </div>
      <span class="content--divider"></span>
      <div class="afterDivider">
        <div class="content--item dateContent">
          <div class="content--date">
            <img
              *ngIf="!landing2"
              class="content--icon"
              src="../../../../assets/icons/calendar.svg"
              alt="Calendario"
            />
            <img
              *ngIf="landing2"
              class="content--icon"
              src="../../../../assets/icons/calendar_black.svg"
              alt="Calendario"
            />
            <p class="content--info">
              {{
                content.creationDate
                  ? (content.creationDate | date)
                  : pendingData
              }}
            </p>
          </div>
          <p class="content--text">{{ 'creationDate' | i18next }}</p>
        </div>
        <div class="content--item dateContent">
          <div class="content--date">
            <img
              *ngIf="!landing2"
              class="content--icon"
              src="../../../../assets/icons/calendar.svg"
              alt="Calendario"
            />
            <img
              *ngIf="landing2"
              class="content--icon"
              src="../../../../assets/icons/calendar_black.svg"
              alt="Calendario"
            />
            <p class="content--info">
              {{
                content.deliveryDate
                  ? (content.deliveryDate | date)
                  : pendingData
              }}
            </p>
          </div>
          <p class="content--text">{{ 'deliveryDate' | i18next }}</p>
        </div>
        <div class="content--item dateContent">
          <div class="content--date">
            <img
              *ngIf="!landing2"
              class="content--icon"
              src="../../../../assets/icons/calendar.svg"
              alt="Calendario"
            />
            <img
              *ngIf="landing2"
              class="content--icon"
              src="../../../../assets/icons/calendar_black.svg"
              alt="Calendario"
            />
            <p class="content--info">
              {{
                content.returnDate ? (content.returnDate | date) : pendingData
              }}
            </p>
          </div>
          <p class="content--text">{{ 'returnDate' | i18next }}</p>
        </div>
      </div>
    </mat-card-content>
    <!-- request - dictamenes -->
    <mat-card-content
      class="judgements"
      *ngIf="type === 'vehicles' && requestType === requestTypeEnum.JUDGEMENTS"
    >
      <div class="judgements--item">
        <p class="judgements--item__info">
          {{ content.plateNumber ? content.plateNumber : '-' }}
        </p>
        <p class="judgements--item__label">{{ 'plateNumber' | i18next }}</p>
      </div>
      <div class="judgements--item">
        <p class="judgements--item__info">
          {{ content.vin ? content.vin : noData }}
        </p>
        <p class="judgements--item__label">{{ 'vin' | i18next }}</p>
      </div>
      <div class="judgements--item">
        <p class="judgements--item__info">
          {{ content.location ? content.location : noData }}
        </p>
        <p class="judgements--item__label">{{ 'location' | i18next }}</p>
      </div>
      <div class="judgements--item">
        <p class="judgements--item__info">
          {{ content.pvResolution ? content.pvResolution : noData }}
        </p>
        <p class="judgements--item__label">{{ 'pvResolution' | i18next }}</p>
      </div>
      <div class="judgements--item">
        <p class="judgements--item__info">
          {{ content.qaResolution ? content.qaResolution : noData }}
        </p>
        <p class="judgements--item__label">{{ 'qaResolution' | i18next }}</p>
      </div>
    </mat-card-content>
    <!-- request - red-plates  -->
    <mat-card-content class="redplates" *ngIf="requestType === 'red-plates'">
      <div class="redplates--item">
        <p class="redplates--item__text">
          {{ content.requirementDate ? content.requirementDate : noData }}
        </p>
        <p class="redplates--item__label">
          {{ 'needDate' | i18next }}
        </p>
      </div>
      <div class="redplates--item">
        <p class="redplates--item__text">
          {{ content.quantityOfPlates ? content.quantityOfPlates : noData }}
        </p>
        <p class="redplates--item__label">
          {{ 'platesOfNumber' | i18next }}
        </p>
      </div>
      <div class="redplates--item">
        <p class="redplates--item__text">
          {{
            content.quantityOfBulletines ? content.quantityOfBulletines : noData
          }}
        </p>
        <p class="redplates--item__label">
          {{ 'numberOfBulletins' | i18next }}
        </p>
      </div>
      <div class="redplates--item">
        <p class="redplates--item__text">
          {{
            content.quantityOfTriplePlates
              ? content.quantityOfTriplePlates
              : noData
          }}
        </p>
        <p class="redplates--item__label">
          {{ 'numberOfTriplePlates' | i18next }}
        </p>
      </div>
    </mat-card-content>
    <!-- request - cesiones -->
    <mat-card-content class="transfers" *ngIf="requestType === 'transfer'">
      <div class="transfers--item">
        <p class="transfers--item__text">
          {{ content.vehicle.plateNumber }}
          <!-- {{ content.plateNumber ? content.plateNumber : noData }} -->
        </p>
        <p class="transfers--item__label">
          {{ 'plateNumber' | i18next }}
        </p>
      </div>
      <div class="transfers--item">
        <p class="transfers--item__text">
          {{ content.vehicle.vin ? content.vehicle.vin : noData }}
        </p>
        <p class="transfers--item__label">
          {{ 'vin' | i18next }}
        </p>
      </div>
      <div class="transfers--item">
        <p class="transfers--info">{{ 'initialDate' | i18next }}</p>
        <div class="transfers--date">
          <img
            class="transfers--icon"
            src="../../../../assets/icons/calendar.svg"
            alt="Calendario"
          />
          <p class="transfers--text">{{ content.deliveryDate }}</p>
        </div>
      </div>
      <div class="transfers--item">
        <p class="transfers--info">{{ 'initialDate' | i18next }}</p>
        <div class="transfers--date">
          <img
            class="transfers--icon"
            src="../../../../assets/icons/calendar.svg"
            alt="Calendario"
          />
          <p class="transfers--text">{{ content.returnDate }}</p>
        </div>
      </div>
    </mat-card-content>
    <!-- request - entrada salida -->
    <mat-card-content class="es" *ngIf="requestType === requestTypeEnum.ES">
      <div class="es--item">
        <p class="es--item__text">
          {{
            content.checkOutDate
              ? (content.checkOutDate | date: 'medium')
              : noData
          }}
        </p>
        <p class="es--item__label">
          {{ 'checkOutDate' | i18next }}
        </p>
      </div>
      <div class="es--item">
        <p class="es--item__text">
          {{
            content.checkInDate
              ? (content.checkInDate | date: 'medium')
              : noData
          }}
        </p>
        <p class="es--item__label">
          {{ 'checkInDate' | i18next }}
        </p>
      </div>
      <div class="es--item">
        <p class="es--item__text">
          {{ content.driver.fullName ? content.driver.fullName : noData }}
        </p>
        <p class="es--item__label">
          {{ 'name' | i18next }}
        </p>
      </div>
      <div class="es--item">
        <p class="es--item__text">
          {{
            content.driver.internalDriverId
              ? content.driver.internalDriverId
              : content.driver.externalDriverId
                ? content.driver.externalDriverId
                : noData
          }}
        </p>
        <p class="es--item__label">
          {{ 'nis' | i18next }}
        </p>
      </div>
      <div
        class="es--item"
        *ngIf="
          content.stockVehicle.vehicles &&
          content.stockVehicle.vehicles.length > 0
        "
      >
        <p class="es--item__text">
          {{
            content.stockVehicle.vehicles[0].plateNumber
              ? content.stockVehicle.vehicles[0].plateNumber
              : noData
          }}
        </p>
        <p class="es--item__label">
          {{ 'plateNumber' | i18next }}
        </p>
      </div>
      <div
        class="es--item"
        *ngIf="
          content.stockVehicle.vehicles &&
          content.stockVehicle.vehicles.length > 0
        "
      >
        <p
          class="es--item__text"
          [title]="content.stockVehicle.vehicles[0].model"
        >
          {{
            content.stockVehicle.vehicles[0].model
              ? content.stockVehicle.vehicles[0].model.length > 20
                ? (content.stockVehicle.vehicles[0].model | slice: 0 : 20) +
                  '...'
                : content.stockVehicle.vehicles[0].model
              : noData
          }}
        </p>
        <p class="es--item__label">
          {{ 'model' | i18next }}
        </p>
      </div>
      <div
        class="es--item"
        *ngIf="
          content.stockVehicle.vehicles &&
          content.stockVehicle.vehicles.length > 0
        "
      >
        <p class="es--item__text">
          {{
            content.stockVehicle.vehicles[0].exteriorColorDescription
              ? content.stockVehicle.vehicles[0].exteriorColorDescription
              : noData
          }}
        </p>
        <p class="es--item__label">
          {{ 'color' | i18next }}
        </p>
      </div>
    </mat-card-content>
    <!-- Authorizations list -->
    <mat-card-content
      class="content autorizationsList"
      *ngIf="
        type === 'authorizations' &&
        authorizationType === authorizationEnum.REQUESTS
      "
    >
      <form
        [formGroup]="form"
        class="content--checkbox"
        *ngIf="
          type === 'authorizations' && content.requestStatus !== 'APPROVED'
        "
      >
        <mat-checkbox
          [value]="content"
          #checkbox
          [checked]="content.checked"
          formControlName="authorization"
          (change)="updateAuthorizationsList($event)"
          color="primary"
        ></mat-checkbox>
      </form>
      <div class="content--item">
        <p class="content--info">
          {{ content.requestNumber ? content.requestNumber : pendingData }}
        </p>
        <p class="content--text">{{ 'requestNumber' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.petitioner ? (content.petitioner | titlecase) : pendingData
          }}
        </p>
        <p class="content--text">{{ 'requestPetitioner' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.requestType
              ? translate.translateRequestTypes(
                  content.orderType ? content.orderType : content.requestType
                )
              : pendingData
          }}
          <span
            *ngIf="content.requestType === 'LOAN'"
            class="content--info__loanSubtype"
            >{{ translate.translateRequestSubtypes(content.loanType) }}</span
          >
        </p>
        <p class="content--text">{{ 'requestType' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.deliveryDate
              ? (content.deliveryDate | date: 'short')
              : pendingData
          }}
        </p>
        <p class="content--text">{{ 'deliveryDate' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.returnDate
              ? (content.returnDate | date: 'short')
              : pendingData
          }}
        </p>
        <p class="content--text">{{ 'returnDate' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.previousApproval
              ? content.previousApproval.idpreviousApproval
                ? content.previousApproval.idpreviousApproval
                    .fullNamepreviousApproval.department
                : noData
              : noData
          }}
        </p>
        <p class="content--text">{{ 'petitioner' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.center ? content.center : pendingData }}
        </p>
        <p class="content--text">{{ 'center' | i18next }}</p>
      </div>
    </mat-card-content>
    <mat-card-content
      class="content autorizationsList"
      *ngIf="
        type === 'authorizations' &&
        authorizationType === authorizationEnum.TRANSFERS
      "
    >
      <form
        [formGroup]="form"
        class="content--checkbox"
        *ngIf="
          type === 'authorizations' && content.requestStatus !== 'APPROVED'
        "
      >
        <mat-checkbox
          [value]="content"
          #checkbox
          [checked]="content.checked"
          formControlName="authorization"
          (change)="updateAuthorizationsList($event)"
          color="primary"
        ></mat-checkbox>
      </form>
      <div class="content--item">
        <p class="content--info">
          {{ content.id ? content.id : noData }}
        </p>
        <p class="content--text">{{ 'requestNumber' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.user.fullName ? (content.user.fullName | titlecase) : noData
          }}
        </p>
        <p class="content--text">{{ 'requestPetitioner' | i18next }}</p>
      </div>
      <div class="content--item">
        <p
          class="content--info"
          [matTooltip]="tooltipTransfer(content.department)"
        >
          {{ content.user.nis ? content.user.nis : noData }}
        </p>
        <p class="content--text">{{ 'nis' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.vehicle
              ? content.vehicle.plateNumber
                ? content.vehicle.plateNumber
                : noData
              : noData
          }}
        </p>
        <p class="content--text">{{ 'plateNumber' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.vehicle
              ? content.vehicle.vin
                ? content.vehicle.vin
                : noData
              : noData
          }}
        </p>
        <p class="content--text">{{ 'vin' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.deliveryDate ? content.deliveryDate : noData }}
        </p>
        <p class="content--text">{{ 'initialDate' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.returnDate ? content.returnDate : noData }}
        </p>
        <p class="content--text">{{ 'endDate' | i18next }}</p>
      </div>
    </mat-card-content>
    <mat-card-content
      class="content autorizationsList"
      *ngIf="
        type === 'authorizations' &&
        authorizationType === authorizationEnum.RED_PLATES
      "
    >
      <form
        [formGroup]="form"
        class="content--checkbox"
        *ngIf="
          type === 'authorizations' &&
          content.requestStatus === 'PENDING_APPROVAL'
        "
      >
        <mat-checkbox
          [value]="content"
          #checkbox
          [checked]="content.checked"
          formControlName="authorization"
          (change)="updateAuthorizationsList($event)"
          color="primary"
        ></mat-checkbox>
      </form>
      <div class="content--item">
        <p class="content--info">
          {{ content.redPlateId ? content.redPlateId : noData }}
        </p>
        <p class="content--text">{{ 'requestNumber' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.petitioner ? content.petitioner : noData }}
        </p>
        <p class="content--text">{{ 'requestPetitioner' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.userId ? content.userId : noData }}
        </p>
        <p class="content--text">{{ 'nis' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.quantityOfPlates ? content.quantityOfPlates : noData }}
        </p>
        <p class="content--text">{{ 'quantityOfPlates' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.quantityOfBulletines ? content.quantityOfBulletines : noData
          }}
        </p>
        <p class="content--text">{{ 'quantityOfBulletines' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{
            content.quantityOfTriplePlates
              ? content.quantityOfTriplePlates
              : noData
          }}
        </p>
        <p class="content--text">{{ 'quantityOfTriplePlates' | i18next }}</p>
      </div>
      <div class="content--item">
        <p class="content--info">
          {{ content.requirementDate ? content.requirementDate : noData }}
        </p>
        <p class="content--text">{{ 'requirementDate' | i18next }}</p>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-paginator
    #paginator
    class="paginator"
    (page)="handlePageEvent($event)"
    [length]="this.dataPagination?.totalResults"
    [pageSize]="this.pageSize"
    [disabled]="false"
    [showFirstLastButtons]="false"
    [pageSizeOptions]="[]"
    [hidePageSize]="hidePageSize"
    [pageIndex]="this.dataPagination?.page - 1 || 0"
    aria-label="Select page"
    [style]="{
      'background-color': landing2 ? 'transparent' : '#2c2a29',
      color: landing2 ? '#000' : '#fff'
    }"
  >
  </mat-paginator>
</section>
